import createAccountReviewStorage from "./factory";
import companyOverviewStorageProvider from "./provider";

const accountReviewStorage = createAccountReviewStorage(companyOverviewStorageProvider);

export default accountReviewStorage;
